<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-invest-icon01.svg" alt="*" />あなたの自己投資マインド
				</span>
			</div><!-- end .type -->
			<div class="cover">
				変革型{{investMindResult.percentageLeft}}%、保守型{{investMindResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>積極的に投資を行うことができ、ハイリターンを得られるマインドを秘めている</h2>
			<img src="../assets/result-detail-invest-outleft01.svg" alt="*" class="visual" />
			<div class="caption">
				豊富な資本と強いマインドで投資を行える準備さえできれば、ロケット級のリターンを得られるだろう
			</div><!-- end .caption -->
			<p>2番目は自己投資の特性を診断しました。なぜなら、内向的か外向的か、その程度の度合いは、自己投資で受けられるリターンを、非常に大きく変える可能性を秘めているからです。</p>
			<p>外向的な人は、物事の本質を掴むことよりも、表に見えることを信じ抜くことに長けています。内向的な人が物事の裏側を読み解こうとしている間に、外向的な人は「これだ！」と決め込んだものがあれば、それに即座に投資する行動体質を持っていると言えるでしょう。</p>
			<p>あなたの自己投資は変革型{{investMindResult.percentageLeft}}%という結果は、あなたの外向型と掛け合わさり、すべてのタイプの中で最も積極的に投資を行うタイプとなりました。</p>
			<p>
				あなたは内向度{{ levelResult.percentage}}%、変革型{{investMindResult.percentageLeft}}%です。内向度が0%に近く、変革型の数値が100%に近くづくほど、より大胆な投資をする傾向が顕著になります。
			</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>プレイヤー型の投資よりも、オーナー型の投資への適性が非常に高い</h2>
			<img src="../assets/result-detail-invest-outleft02.svg" alt="*" class="visual" />
			<div class="caption">
				あなたがオーナーマインドをセットすることができれば、投資の才能が一気に開花される
			</div><!-- end .caption -->
			<p>正直、外向性が高いあなたは、自分の専門的なスキルを身に着けることに投資することはあまりおススメしません。</p>
			<p>外向度の高い人のエネルギーは、基本的には、「誰かに」「誰かと」という方向性を向いています。しかし、専門的なスキルを持ったプレイヤーというのは、「自分が何を掘り下げて提供できるのか」という魂に溢れ、そこに正面から向き合っています。</p>
			<p>そもそも外向性が高い人は、コミュニケーター、マネージャー、オーナーの才能を持っています。そして、あなたは、自己投資に変革的な態度を高く取ることができるため、外向性の中の人の中でも、さらにオーナー気質を持っています。投資を考えるときは、プレイヤーとしての自分に投資するよりも、オーナーとして他人や他の会社や投資を行い、そのリターンを得ることに適性があります。</p>
			<p>専門性の高い知識や技術の習得には、かなり深い内向的な時間や反復作業が求められます。外向型の人は文字通り、人生の中で圧倒的に外向的な時間や作業が多くなります。もし、外向型の人がプレイヤーとして自己投資をするなら、熟練するために外向的要因が大きく必要な分野に投資すると良いでしょう。</p>
			<p>オーナーとして一任する場合は、内向型のプロフェッショナルを選び、彼らに自由な思考の下で動いてもらうと高いリターンが得られる可能性が高いです。思考やノウハウを自分に頼らず、外に正しく任せられるかどうかがあなたにとってはとても重要になります。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自己投資によって、自分の代わりに活躍する武器を揃えていこう</h2>
			<img src="../assets/result-detail-invest-outleft03.svg" alt="*" class="visual" />
			<div class="caption">
				他人本位だからこそ、他人に振り撒けるスキルや能力が増えれば、あなたの内向的個性はガツンと煌めく
			</div><!-- end .caption -->
			<p>このタイプの人の将来設計は、「自分が動く」側に立つのではなく、「自分が動かす」側に立つということがとても向いています。結果的に、投資の目的は、「自分が動かなくても済むためのもの」となるわけです。自分が働かなくても回る設備や人材がそうでしょう。自分が直接伝えに行かなくても、魅力が伝わるようなWebサイトを作ることもそうでしょう。</p>
			<p>自分が会社員に留まらず、株式投資を行い、「働かなくてもお金が回る」という状態に投資することも、このタイプの人生を大きく引き上げることに繋がります。</p>
			<p>本当に良いモノや人に、大きな額を投じ続けることで、自分の人生があまりにも大きく急上昇します。中途半端に安く済ませたり、質を気にしなかったりすると、積極的に投資はしているのに、まったくリターンが得られない人生になってしまいます。</p>
			<p>外向的で自己投資が変革型の人は、プレイヤーとして優れている必要はありません。ただし、携わる分野に関しては、情報収集や分析を自分なりに行い「リテラシー」を高める工夫をしてみて下さい。</p>
			<p>リテラシーが高く、外向性が高い人は、本当に良いモノや人に出会える確率が高くなります。あなたの投資気質は変革型ですから、どんどん投資を試みていきます。リテラシーを高める作業をするかしないかは、あなたのようなタイプの人生には甚大な影響を与えていくでしょう。</p>
		</div><!-- end .sentence -->
</div><!-- end .contents -->				
</template>

<script>


export default {
	name: 'ResultDetailInvestOutLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[
	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},
		//investMind
		investMindResult:function(){
			return this.$store.getters.investMindResult
		},	
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
